import React from 'react';
import PropTypes from 'prop-types';

const Ico = ({ size = 16, stroke = 1.5, children, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={stroke}
    strokeLinecap="round"
    strokeLinejoin="round"
    {...rest}
  >
    {children}
  </svg>
);
Ico.propTypes = { size: PropTypes.number, stroke: PropTypes.number, children: PropTypes.node };

export const IcoShield = p => (
  <Ico {...p}>
    <path d="M12 3l8 3v6c0 4.6-3.4 8.4-8 9-4.6-.6-8-4.4-8-9V6l8-3z" />
  </Ico>
);
export const IcoCompass = p => (
  <Ico {...p}>
    <circle cx="12" cy="12" r="9" />
    <path d="M16 8l-2 6-6 2 2-6 6-2z" />
  </Ico>
);
export const IcoOrbit = p => (
  <Ico {...p}>
    <circle cx="12" cy="12" r="3" />
    <ellipse cx="12" cy="12" rx="9" ry="4" transform="rotate(-30 12 12)" />
  </Ico>
);
export const IcoGauge = p => (
  <Ico {...p}>
    <path d="M12 14l4-4" />
    <path d="M4.5 16a8 8 0 1115 0" />
    <circle cx="12" cy="14" r="1.2" fill="currentColor" />
  </Ico>
);
export const IcoBug = p => (
  <Ico {...p}>
    <rect x="7" y="8" width="10" height="12" rx="5" />
    <path d="M12 8V5M9 5l-2-2M15 5l2-2M7 12H4M7 16H4M17 12h3M17 16h3M9 20l-2 2M15 20l2 2" />
  </Ico>
);
export const IcoBolt = p => (
  <Ico {...p}>
    <path d="M13 2L4 14h7l-1 8 9-12h-7z" />
  </Ico>
);
export const IcoCheck = p => (
  <Ico {...p}>
    <path d="M4 12l5 5 11-12" />
  </Ico>
);
export const IcoX = p => (
  <Ico {...p}>
    <path d="M5 5l14 14M19 5L5 19" />
  </Ico>
);
export const IcoChev = p => (
  <Ico {...p}>
    <path d="M6 9l6 6 6-6" />
  </Ico>
);
export const IcoChevR = p => (
  <Ico {...p}>
    <path d="M9 6l6 6-6 6" />
  </Ico>
);
export const IcoChevL = p => (
  <Ico {...p}>
    <path d="M15 6l-6 6 6 6" />
  </Ico>
);
export const IcoSearch = p => (
  <Ico {...p}>
    <circle cx="11" cy="11" r="7" />
    <path d="M21 21l-4-4" />
  </Ico>
);
export const IcoBell = p => (
  <Ico {...p}>
    <path d="M6 8a6 6 0 0112 0v5l2 3H4l2-3V8z" />
    <path d="M10 19a2 2 0 004 0" />
  </Ico>
);
export const IcoUser = p => (
  <Ico {...p}>
    <circle cx="12" cy="8" r="4" />
    <path d="M4 20a8 8 0 0116 0" />
  </Ico>
);
export const IcoGrid = p => (
  <Ico {...p}>
    <rect x="3" y="3" width="7" height="7" rx="1" />
    <rect x="14" y="3" width="7" height="7" rx="1" />
    <rect x="3" y="14" width="7" height="7" rx="1" />
    <rect x="14" y="14" width="7" height="7" rx="1" />
  </Ico>
);
export const IcoLayers = p => (
  <Ico {...p}>
    <path d="M12 3l9 5-9 5-9-5 9-5z" />
    <path d="M3 13l9 5 9-5M3 18l9 5 9-5" />
  </Ico>
);
export const IcoSpark = p => (
  <Ico {...p}>
    <path d="M12 3v4M12 17v4M3 12h4M17 12h4M5.6 5.6l2.8 2.8M15.6 15.6l2.8 2.8M5.6 18.4l2.8-2.8M15.6 8.4l2.8-2.8" />
  </Ico>
);
export const IcoBook = p => (
  <Ico {...p}>
    <path d="M4 5a2 2 0 012-2h12v18H6a2 2 0 01-2-2V5z" />
    <path d="M8 7h8M8 11h8M8 15h5" />
  </Ico>
);
export const IcoCog = p => (
  <Ico {...p}>
    <circle cx="12" cy="12" r="3" />
    <path d="M19 12a7 7 0 00-.1-1.3l2-1.5-2-3.4-2.4.9a7 7 0 00-2.2-1.3L13.7 3h-3.4l-.6 2.4a7 7 0 00-2.2 1.3l-2.4-.9-2 3.4 2 1.5A7 7 0 005 12c0 .4 0 .9.1 1.3l-2 1.5 2 3.4 2.4-.9a7 7 0 002.2 1.3l.6 2.4h3.4l.6-2.4a7 7 0 002.2-1.3l2.4.9 2-3.4-2-1.5c.1-.4.1-.9.1-1.3z" />
  </Ico>
);
export const IcoLife = p => (
  <Ico {...p}>
    <circle cx="12" cy="12" r="9" />
    <circle cx="12" cy="12" r="3" />
    <path d="M5.5 5.5l3.5 3.5M15 15l3.5 3.5M18.5 5.5L15 9M9 15l-3.5 3.5" />
  </Ico>
);
export const IcoBuilding = p => (
  <Ico {...p}>
    <rect x="4" y="3" width="16" height="18" rx="1" />
    <path d="M9 7h.01M15 7h.01M9 11h.01M15 11h.01M9 15h.01M15 15h.01M10 21v-4h4v4" />
  </Ico>
);
export const IcoPlug = p => (
  <Ico {...p}>
    <path d="M9 7V3M15 7V3M7 11h10v3a5 5 0 01-10 0v-3zM12 19v3" />
  </Ico>
);
export const IcoUsers = p => (
  <Ico {...p}>
    <circle cx="9" cy="8" r="3" />
    <path d="M3 20a6 6 0 0112 0" />
    <circle cx="17" cy="9" r="2" />
    <path d="M15 20a4 4 0 018 0" />
  </Ico>
);
export const IcoActivity = p => (
  <Ico {...p}>
    <path d="M3 12h4l3-8 4 16 3-8h4" />
  </Ico>
);
export const IcoFile = p => (
  <Ico {...p}>
    <path d="M14 3H6a2 2 0 00-2 2v14a2 2 0 002 2h12a2 2 0 002-2V9l-6-6z" />
    <path d="M14 3v6h6" />
  </Ico>
);
export const IcoArrowR = p => (
  <Ico {...p}>
    <path d="M5 12h14M13 6l6 6-6 6" />
  </Ico>
);
export const IcoLogout = p => (
  <Ico {...p}>
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
    <path d="M16 17l5-5-5-5" />
    <path d="M21 12H9" />
  </Ico>
);
export const IcoFilter = p => (
  <Ico {...p}>
    <path d="M3 5h18l-7 9v6l-4-2v-4L3 5z" />
  </Ico>
);
export const IcoClock = p => (
  <Ico {...p}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7v5l3 2" />
  </Ico>
);
export const IcoSlash = p => (
  <Ico {...p}>
    <path d="M16 5L8 19" />
  </Ico>
);
